import React from "react";
import PropTypes from "prop-types";

import Avatar from "@material-ui/core/Avatar";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemText from "@material-ui/core/ListItemText";
import Dialog from "@material-ui/core/Dialog";
import ExitIcon from "../icons/ExitIcon";
import translate from '../other/translate.json'
import IconButton from '@material-ui/core/IconButton';
import { Badge }from '@material-ui/core'
import AutorizationIcon from '../icons/AutorizationIcon';
import config from '../other/config';
import { withStyles, makeStyles } from '@material-ui/core/styles';
const {serverAPI} = config;


const StyledBadge = withStyles((theme) => ({
	badge: {
		top: 44,
		right: 4,
		height: 10,
		width: 10,
		borderRadius: 5,
		backgroundColor: 'rgb(129, 211, 157)'
	},
}))(Badge);

export default function Autorization(props) {
  const [open, setOpen] = React.useState(false);
  const { usname, setUsname, isAuth, setIsAuth, kloUser, showBankSelect, _showBankSelect } = props

  // const [selectedValue, setSelectedValue] = React.useState(usname);

  function handleClickOpen() {
    setOpen(true);
  };



  function handleClose() {
    setOpen(false);
  };
  function logoutEvent() {
    setOpen(false);
    setUsname('')
    setIsAuth(false)
    window.location.href = '/logout?linkTo='+ window.location.href;
  };
  return (
    <React.Fragment>
      {isAuth ?
        <React.Fragment>
          <IconButton aria-label="avatar" style={{ width: 48, height: 48, padding: 0 }} onClick={handleClickOpen} /*kloBadge ={kloUser.user && kloUser.user.IS_BANK && showBankSelect}*/>
            <Avatar style={{ width: 48, height: 48, backgroundColor: '#3C3C56' }}>{ usname !== undefined && usname.usname !== undefined ?  usname.usname[0] : ''}</Avatar>
          </IconButton>

          <SimpleDialog
            lang={props.lang}
            usname={usname !== undefined && usname.usname !== undefined ?  usname.usname : ''}
            organization={usname !== undefined && usname.organization !== undefined ?  usname.organization : ''}
            open={open}
            onClose={handleClose}
            logoutEvent={logoutEvent}
          />
        </React.Fragment>
        // : <a href='https://accounts.cft.ru/adfs/ls/?SAMLRequest=nZLfT4MwEMf%2FFdJ3oAM3TTNY5vbgkhmXDX3wxZRSNiK02Dt0f76FDcODLnFPTe%2Fn93N309mxKp1PaaDQKiIjj5JZPAVelTWbN3hQW%2FnRSEDHhilgnSMijVFMcyiAKV5JYCjYbv64ZoFHWW00aqFL4qyWEXkTYToJc5plgoZUhnk6GWfEeekb2gwbCNDIlQLkCq2JBiOXBu7oNqETRu8YnXjj8c0rcTbn0veFygq1v6wjPQUBe0iSjbt52iXEmQNIg7bxQitoKml20nwWQj5v1xE5INbAfD8FV3Dkpd67aMm9HIVnGt%2F%2BC%2BULXpYpF%2B8BcZbWWSiOHUefzIXQjULwRI5tFs9y8Esgp5myjtQMhnmZgfd6SfwvdVN%2F0K1f53mTMuv2aieA8njVXhe6qrkpoOWWRy6wpxsWXpRW%2FFbm17BeDBNMtKWteWOfL22y9iyksGCJ4QpqbfDM%2F5ue%2BOT7Yxw%2F3uHtx98%3D'> login</a>
        :
        <React.Fragment>
          <IconButton  aria-label="avatar" style={{ width: 48, height: 48, padding: 0 }}  
          // href='https://accounts.cft.ru/adfs/ls/?SAMLRequest=jZFPTwIxEMW%2FStP7%2FqsBoVmWrHKQBCOB1YMXU8osNHZb7LTEj29lJeKFeJzOm%2FebNy2nn50mR3CorJnQIs3ptCpRdPrA6%2BD3ZgUfAdCTKDPIT40JDc5wK1AhN6ID5F7ydf244CzN%2BcFZb6XVlMxnE%2Fo2hM2obRmMxyMQtzfFaMiAkpczME5EIWKAuUEvjI9POSuSnCVs0ORjnjPOipSxwSslyx%2FrO2W2yuyu77HpRcgfmmaZLJ%2FWDSWzmEQZ4U%2FovfcH5FkmpLTBeExl61MXMrFtMdNISY0I7lt7bw2GDtwa3FFJeF4tfqel8ELbXeKj9dkh1srEjtYbId8Z7Q%2FKTzHdxSWvBxBnPK3%2BDyuzC1TVV39%2FsvoC'>
          href={`${serverAPI}/login`+ '?linkTo='+ window.location.href}>
            {
              kloUser.user && kloUser.user.IS_BANK && kloUser.showBankSelect === true && false
              ?
              <StyledBadge
								color="secondary"
								variant="dot"
							>
                <Avatar style={{ width: 48, height: 48, backgroundColor: '#3C3C56' }}><AutorizationIcon /></Avatar>
              </StyledBadge>
              :
            <Avatar style={{ width: 48, height: 48, backgroundColor: '#3C3C56' }}><AutorizationIcon /></Avatar>
            }
          </IconButton>
          {/* <a href='https://accounts.cft.ru/adfs/ls/?SAMLRequest=jZFPTwIxEMW%2FStP7%2FqsBoVmWrHKQBCOB1YMXU8osNHZb7LTEj29lJeKFeJzOm%2FebNy2nn50mR3CorJnQIs3ptCpRdPrA6%2BD3ZgUfAdCTKDPIT40JDc5wK1AhN6ID5F7ydf244CzN%2BcFZb6XVlMxnE%2Fo2hM2obRmMxyMQtzfFaMiAkpczME5EIWKAuUEvjI9POSuSnCVs0ORjnjPOipSxwSslyx%2FrO2W2yuyu77HpRcgfmmaZLJ%2FWDSWzmEQZ4U%2FovfcH5FkmpLTBeExl61MXMrFtMdNISY0I7lt7bw2GDtwa3FFJeF4tfqel8ELbXeKj9dkh1srEjtYbId8Z7Q%2FKTzHdxSWvBxBnPK3%2BDyuzC1TVV39%2FsvoC'> login</a> */}
        </React.Fragment>
      }
    </React.Fragment>
  );
}

const useStyles = makeStyles({
  avatar: {
    backgroundColor: '#3C3C56',
    color: '#FFFFFF',
    width: 48,
    height: 48,
    marginRight: 9
  },

  DialogRoot: {
    // backgroundColor: "red",

    "& .MuiBackdrop-root": {
      backgroundColor: "transparent"
    },

    "& .MuiDialog-paper": {
      boxShadow: "6px 6px 30px 0px rgba(35,72,152,0.2)",
      position: "absolute",
      top: "64px",
      right: "-8px",
      borderRadius: '16px',
      // minWidth: 293
    }
  }
});

function SimpleDialog(props) {
  const classes = useStyles();
  const { onClose, open, lang, logoutEvent } = props;

  function handleClose() {
    onClose();
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
      className={classes.DialogRoot}
    >
      {/* <DialogTitle id="simple-dialog-title">Set backup account</DialogTitle> */}
      <List>
        <a href='https://accounts.cft.ru/my/Account/Edit' style={{ color: 'unset', textDecoration: 'none' }}>
          <ListItem
            // button
            onClick={() => handleClose()}
          // onClick={() => handleClose()} /* ИЗМЕНИТЬ */
          // key={emails}
          >
            <ListItemAvatar>
              {/* <Avatar className={classes.avatar}> */}
              <Avatar style={{ width: 48, height: 48, backgroundColor: '#3C3C56' }}>{props.usname[0]||''}</Avatar>
              {/* <PersonIcon /> */}
              {/* </Avatar> */}
            </ListItemAvatar>
            <ListItemText primary={props.usname} secondary={props.organization} />
          </ListItem>
        </a>

        <ListItem
          autoFocus
          button
          onClick={() => logoutEvent()}
        >
          <ListItemAvatar>
            {/* <Avatar> */}
            <ExitIcon fill={"#BCBBD0"} />
            {/*  https://catalog-test.cft.ru/logout    POST   */}
            {/* </Avatar> */}
          </ListItemAvatar>
          <ListItemText primary={translate.TopMenu[`Exit${lang}`]} />
        </ListItem>
      </List>
    </Dialog>
  );
}

SimpleDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired
};
